var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let state = null;
/**
 * Initialize the state by reading the default global settings from the DOM.
 *
 * @returns {boolean}
 *   Whether or not the state has initialized.
 */
const initializeState = () => {
    if (state === null) {
        try {
            state = JSON.parse(document.getElementById('js-global-state').getAttribute('data-state'));
        }
        catch (error) {
            return false;
        }
    }
    return true;
};
/**
 * Get a state.
 *
 * @param {string} key
 * @param {*} defaultValue
 *
 * @returns {*}
 */
export const getGlobalState = (key, defaultValue = null) => {
    const stateInitialized = initializeState();
    if (stateInitialized) {
        if (state[key] === undefined && defaultValue !== null) {
            state[key] = defaultValue;
        }
        return state[key];
    }
    return null;
};
/**
 * Set or override a global state setting.
 *
 * @param {string} key
 * @param {string|function} value
 *   Either the value to set or a callback to call for the value.
 */
export const setGlobalState = (key, value) => {
    const stateInitialized = initializeState();
    if (stateInitialized) {
        if (typeof value === 'function') {
            (() => __awaiter(void 0, void 0, void 0, function* () {
                state[key] = yield value(state);
            }))();
        }
        else {
            state[key] = value;
        }
    }
};
export const getPaymentServiceUrl = () => {
    // in some apps js-global state might be not defined so fallback to production url.
    return getGlobalState('payment_url', 'https://payment.testaviva.dk');
};
